import { render, staticRenderFns } from "./EstadosContablesView.vue?vue&type=template&id=5a4cb4b2&scoped=true"
import script from "./EstadosContablesView.vue?vue&type=script&lang=js"
export * from "./EstadosContablesView.vue?vue&type=script&lang=js"
import style0 from "./EstadosContablesView.vue?vue&type=style&index=0&id=5a4cb4b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4cb4b2",
  null
  
)

export default component.exports